import Tags from "../../shared/tags";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    sortAlphabetically: { type: Boolean, default: false }
  }

  connect() {
    if (!this.element.id) {
      this.element.id = `tags-${Math.random().toString(36).substr(2, 9)}`;
    }
    Tags.init(`#${this.element.id}`);
    this.element._tags = this.element._tags || Tags.getInstance(this.element);

    if (this.sortAlphabeticallyValue) {
      this.setupSorting()
    }
  }

  disconnect() {
    if (this.sortHandler) {
      this.element.removeEventListener("change", this.sortHandler)
    }
    if (this.element._tags) {
      this.element._tags.dispose();
    }
  }

  setupSorting() {
    const dropdownContainer = this.element.previousElementSibling
    if (!dropdownContainer || !dropdownContainer.classList.contains("dropdown")) {
      setTimeout(() => this.setupSorting(), 50)
      return
    }

    this.tagsContainer = dropdownContainer.querySelector('div[style*="flex"]')
    if (!this.tagsContainer) {
      setTimeout(() => this.setupSorting(), 50)
      return
    }

    this.sortHandler = () => {
      setTimeout(() => this.sortTags(), 0)
    }
    this.element.addEventListener("change", this.sortHandler)

    this.sortTags()
  }

  sortTags() {
    const tags = Array.from(this.tagsContainer.querySelectorAll("span.badge, span[data-value]"))

    if (tags.length < 2) return

    const input = this.tagsContainer.querySelector("input")
    const hadFocus = document.activeElement === input

    tags.sort((a, b) => {
      const textA = a.textContent.trim().toLowerCase()
      const textB = b.textContent.trim().toLowerCase()
      return textA.localeCompare(textB, "nl")
    })

    tags.forEach(tag => this.tagsContainer.appendChild(tag))
    if (input) {
      this.tagsContainer.appendChild(input)
      if (hadFocus) {
        input.focus()
      }
    }
  }
}
